define('ItemSearch.API.Fix', [
    'RecentlyViewedItems.Collection',
    'ItemRelations.Correlated.Collection.Fix',
    'ItemRelations.Related.Collection.Fix'
], function ItemSearchAPIFix(
) {
    'use strict';

    return {};
});

